// utils/index.js
export function createPageUrl(entity) {
  return `/pages/${entity}`;
}

// ── Page view tracking ──────────────────────────────────────
// Generates a per-session ID stored in sessionStorage so we
// can approximate unique visitors without cookies.
function getSessionId() {
  const key = '__sv_sid';
  let sid = sessionStorage.getItem(key);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(key, sid);
  }
  return sid;
}

export async function trackPageView(page) {
  try {
    // Lazy-import to avoid circular deps
    const { supabase } = await import('./supabase.js');
    await supabase.from('page_views').insert({
      session_id: getSessionId(),
      page,
      referrer: document.referrer || null,
    });
  } catch {
    // Silently ignore – tracking must never break the app
  }
}
